import injectSheet from 'react-jss';

import TooltipContent from './component';
import styles from './styles';

export default injectSheet(styles)(TooltipContent);
